import { defineNuxtPlugin, useRoute } from '#app'
import { useUserInfo, watch } from '#imports'

export default defineNuxtPlugin(() => {
    const { userJustLoggedIn, userJustSignedUp } = useUserInfo()

    // Cleanup auth cookies
    const route = useRoute()

    if (userJustLoggedIn.value) {
        // Set userJustLoggedIn to false after route change
        const stop = watch(() => route.path, () => {
            userJustLoggedIn.value = undefined

            stop()
        })
    }

    if (userJustSignedUp.value) {
        // Set userJustSignedUp to false after route change
        const stopUserJustSignedUp = watch(() => route.path, () => {
            userJustSignedUp.value = undefined

            stopUserJustSignedUp()
        })
    }
    // ./ Cleanup auth cookies
})
